import { UserType } from '../../context/SignupContext';

export type InfluencerStep = 0 | 1 | 2 | 3 | 4;
const influencerSteps: Record<InfluencerStep, string> = {
  0: '/signup/select-profile',
  1: '/signup/choose-categories',
  // 2: '/signup/choose-collaborations',
  2: '/signup/upload-headshot',
  3: '/signup/social-accounts',
  4: '/signup/pricing-setup',
};

export type CreatorStep = 0 | 1;
const creatorSteps: Record<CreatorStep, string> = {
  0: '/signup/select-profile',
  1: '/signup/plan-setup'
};

// 3: '/signup/upload-cover-photo',
export type ArtistStep = 0 | 1 | 2 | 3;
const artistSteps: Record<ArtistStep, string> = {
  0: '/signup/select-profile',
  1: '/signup/artstyle-agreement',
  2: '/signup/finetune-model',
  3: '/signup/artstyle-pricing',
};



export const getStepUrls = (userType: UserType | undefined, currentStep: CreatorStep | InfluencerStep | ArtistStep) => {

  if (!userType) {
    return {
      previousUrl: null,
      nextUrl: null
    };
  }

  const steps = (userType === 'influencer' ? influencerSteps : userType === 'creator' ? creatorSteps : artistSteps) as Record<number, string>;

  const prevStep = currentStep - 1;
  const nextStep = currentStep + 1;

  return {
    previousUrl: steps[prevStep] || null,
    nextUrl: steps[nextStep] || null
  };
};
